export const ACCESSORY_ITEM_TEST_ID = {
  productName: 'product-name',
};
